declare namespace $ {

	type $shm_hitalama_map_widget_float_viewport_frame_number__value_shm_hitalama_map_widget_float_viewport_frame_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_viewport_frame['text'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_viewport_frame_number['value'] >
	>
	type $shm_hitalama_map_widget_float_viewport_frame_number__options_shm_hitalama_map_widget_float_viewport_frame_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_viewport_frame['options'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_viewport_frame_number['options'] >
	>
	type $shm_hitalama_map_widget_float_viewport_frame_number__style_shm_hitalama_map_widget_float_viewport_frame_3 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_widget_float_viewport_frame['num_style_transform'] >,
		}) 
		,
		ReturnType< $shm_hitalama_map_widget_float_viewport_frame_number['style'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_float_viewport_frame_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_viewport_frame_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_viewport_frame['width'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_float_viewport_frame_6 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_float_viewport_frame_7 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_float_viewport_frame_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_viewport_frame_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_viewport_frame['height'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_float_viewport_frame_10 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_float_viewport_frame_11 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_float_viewport_frame_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_viewport_frame_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_viewport_frame['ratio_str'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_viewport_frame_14 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__options_shm_hitalama_map_widget_float_viewport_frame_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['options'] >
	>
	type $shm_hitalama_map_page_contextmenu__Map_page_shm_hitalama_map_widget_float_viewport_frame_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_viewport_frame['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['Map_page'] >
	>
	export class $shm_hitalama_map_widget_float_viewport_frame extends $shm_hitalama_map_widget_float {
		text( next?: string ): string
		options( ): readonly(any)[]
		num_style_transform( ): string
		Num( ): $shm_hitalama_map_widget_float_viewport_frame_number
		Width_label( ): $mol_paragraph
		Width( ): $mol_number
		Height_label( ): $mol_paragraph
		Height( ): $mol_number
		Ratio_label( ): $mol_paragraph
		ratio_str( next?: string ): string
		Ratio( ): $mol_select
		save_last_size( ): any
		head_showed( ): boolean
		controls( ): readonly(any)[]
		Contextmenu_body( ): $shm_hitalama_map_page_contextmenu
		settings_content( ): readonly(any)[]
		auto( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=frame.view.tree.d.ts.map